module.exports = __webpack_public_path__ + "static/media/0217_Small.13c92050.jpg";